import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Accordion, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { Rate, VariableRate } from '../../../../../../../ui/rate';
import { useLoanSummary } from '../../hooks/useLoanSummary';

type MobileLoanSummaryProps = {
    formalOffer: TFormalOffer;
    drawdownAmount: number;
};

export const MobileLoanSummary = ({
    formalOffer,
    drawdownAmount
}: MobileLoanSummaryProps) => {
    const { interestRate, withdrawalFeePercentage, fullTermMonths } =
        useLoanSummary(formalOffer, drawdownAmount);

    return (
        <Accordion.Item
            data-testid="mobile-loan-summary"
            variant="secondary"
            size="large"
            className="rounded-s bg-secondary-95"
        >
            <Accordion.Header>
                <Accordion.Title className="text-m font-bold text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.loan_summary.title"
                        defaultMessage="Your loan summary"
                    />
                </Accordion.Title>
                <Accordion.Trigger />
            </Accordion.Header>
            <Accordion.Content>
                <div className="flex flex-col gap-m">
                    <div className="flex items-center justify-between">
                        <Text>
                            <FormattedMessage
                                id="_.loan_summary.withdrawal_amount"
                                defaultMessage="Withdrawal amount:"
                            />
                        </Text>
                        <Text className="font-bold">
                            <FormattedCurrency value={drawdownAmount} />
                        </Text>
                    </div>
                    <div className="flex items-center justify-between">
                        <Text>
                            <FormattedMessage
                                id="_.loan_summary.interest_rate"
                                defaultMessage="Interest rate /30 days:"
                            />
                        </Text>
                        <Text className="font-bold">
                            <Rate value={interestRate} />
                        </Text>
                    </div>
                    <div className="flex items-center justify-between">
                        <Text>
                            <FormattedMessage
                                id="_.loan_summary.withdrawal_fees"
                                defaultMessage="Withdrawal fees:"
                            />
                        </Text>
                        <Text className="font-bold">
                            <VariableRate
                                minimumFractionDigits={0}
                                maximumFractionDigits={2}
                                value={withdrawalFeePercentage}
                            />
                        </Text>
                    </div>
                    <div className="flex items-center justify-between">
                        <Text>
                            <FormattedMessage
                                id="_.loan_summary.full_term_duration"
                                defaultMessage="Full term duration:"
                            />
                        </Text>
                        <Text className="font-bold">
                            <FormattedMessage
                                id="_.loan_summary.full_term_months"
                                defaultMessage="{months} months"
                                values={{ months: fullTermMonths }}
                            />
                        </Text>
                    </div>
                </div>
            </Accordion.Content>
        </Accordion.Item>
    );
};
